const repositionList = ({ list, elementIndex, targetIndex }) => {
  if (!list.length) return [];

  targetIndex = ensureIndexWithinBounds(list, targetIndex);

  const element = list[elementIndex];
  const filteredArray = removeElementFromList(list, elementIndex);
  const updatedArray = insertAtPosition(filteredArray, element, targetIndex);

  return updatePositions(updatedArray);
};

export const repositionUp = (list, elementIndex) => {
  return repositionList({ list, elementIndex, targetIndex: elementIndex - 1 });
};

export const repositionDown = (list, elementIndex) => {
  return repositionList({ list, elementIndex, targetIndex: elementIndex + 1 });
};

const ensureIndexWithinBounds = (list, index) => {
  const lastIndex = list.length - 1;

  if (index < 0) return 0;
  if (index > lastIndex) return lastIndex;

  return index;
};

const removeElementFromList = (list, elementIndex) => {
  return list.filter((_currentElement, index) => {
    return index !== elementIndex;
  });
};

const insertAtPosition = (list, element, targetIndex) => {
  const leadingElements = list.slice(0, targetIndex);
  const trailingElements = list.slice(targetIndex);

  return [...leadingElements, element, ...trailingElements];
};

const updatePositions = (list) => {
  return list.map((element, index) => {
    return { ...element, position: index + 1 };
  });
};

export { repositionList };
